import { ClosingReasonFragment, ProcessStatusFragment } from '@/graphql/fragments/settings'
import gql from 'graphql-tag'

export const getDailyAccountBalance = gql`
  query DailyAccountBalance($start_date: date, $end_date: date) {
    records: finance_daily_account_balance(where: {date: {_gte: $start_date, _lte: $end_date}}) {
      id
      date
      accountBalance: account_balance
      availableBalance: available_balance
      bankAccount: bank_account {
        id
        accountNumber: account_number
        metadata
        bank {
          id
          alias
        }
      }
    }
  }
`

export const getPendingFinancePayments = gql`
  ${ProcessStatusFragment}
  ${ClosingReasonFragment}
  query PendingFinancingPayment {
    records: finance_payment(where: {_and: {payment_type: {name: {_eq: "financing"}}, status: {status: {name: {_eq: "pending_payment"}}}}}) {
      id
      amount
      deal {
        id
        auto {
          id
          registrationPlate: registration_plate
          version: version_year {
            id
            year {
              id
            }
            version {
              id
              name
              model {
                id
                name
                brand {
                  id
                  name
                }
              }
            }
          }
        }
        stock {
          id
          soldDate: sold_date
        }
        saleOrders: sale_orders {
          id
          financings {
            id
            evaluations {
              id
              closingReason: closing_reason {
                ...ClosingReason
              }
              status {
                ...ProcessStatus
              }
              offers {
                id
                fee
              }
            }
          }
        }
      }
      payer {
        id
        alias
        metadata
      }
    }
  }
`
